import { CreateEntityTabPage } from "../shared/CreateEntityTabPage";

export function CreateSupplierPage(): JSX.Element {
  return <CreateEntityTabPage entityType="supplier" />;
}
